import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChangeBrand = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "none",
	viewBox: "0 0 32 32",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M27.7913 21H29.2913V28H27.7913V27.53C27.4613 27.91 26.9713 28.14 26.3013 28.14C24.9913 28.14 23.9113 26.99 23.9113 25.5C23.9113 24.01 24.9913 22.86 26.3013 22.86C26.9713 22.86 27.4613 23.09 27.7913 23.47V21ZM26.6013 26.72C27.2913 26.72 27.7913 26.25 27.7913 25.5C27.7913 24.75 27.2913 24.28 26.6013 24.28C25.9113 24.28 25.4113 24.75 25.4113 25.5C25.4113 26.25 25.9113 26.72 26.6013 26.72Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M21.2612 22.86C22.2712 22.86 23.1312 23.58 23.1312 24.93V28H21.6312V25.15C21.6312 24.53 21.2412 24.24 20.7612 24.24C20.2112 24.24 19.8312 24.56 19.8312 25.27V28H18.3312V23H19.8312V23.47C20.1012 23.1 20.6012 22.86 21.2612 22.86Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M15.7308 23H17.2308V28H15.7308V27.53C15.4008 27.91 14.9108 28.14 14.2408 28.14C12.9308 28.14 11.8508 26.99 11.8508 25.5C11.8508 24.01 12.9308 22.86 14.2408 22.86C14.9108 22.86 15.4008 23.09 15.7308 23.47V23ZM14.5408 26.72C15.2308 26.72 15.7308 26.25 15.7308 25.5C15.7308 24.75 15.2308 24.28 14.5408 24.28C13.8508 24.28 13.3508 24.75 13.3508 25.5C13.3508 26.25 13.8508 26.72 14.5408 26.72Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M10.0461 23.89C10.2461 23.22 10.9161 22.9 11.5461 22.9V24.6C10.9261 24.5 10.0461 24.75 10.0461 25.74V28H8.54608V23H10.0461V23.89Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M6.93998 24.37C7.45998 24.7 7.79998 25.24 7.79998 25.95C7.79998 27.19 6.78998 28 5.53998 28H2.59998V21H5.33998C6.55998 21 7.54998 21.79 7.54998 23C7.54998 23.58 7.31998 24.04 6.93998 24.37ZM5.33998 22.5H4.19998V23.74H5.33998C5.69998 23.74 5.94998 23.48 5.94998 23.12C5.94998 22.76 5.70998 22.5 5.33998 22.5ZM5.53998 26.5C5.93998 26.5 6.19998 26.22 6.19998 25.83C6.19998 25.44 5.93998 25.16 5.53998 25.16H4.19998V26.5H5.53998Z"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#pet__clip0_3715_11209)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "black",
				d: "M8 11C8 11.5531 8.44687 12 9 12C9.55313 12 10 11.5531 10 11C10 9.34375 11.3438 8 13 8H18V9C18 9.40312 18.2437 9.76875 18.6187 9.925C18.9937 10.0813 19.4219 9.99375 19.7094 9.70937L21.7094 7.70937C22.1 7.31875 22.1 6.68437 21.7094 6.29375L19.7094 4.29375C19.4219 4.00625 18.9937 3.92187 18.6187 4.07812C18.2437 4.23437 18 4.59687 18 5V6H13C10.2375 6 8 8.2375 8 11ZM24 13C24 12.4469 23.5531 12 23 12C22.4469 12 22 12.4469 22 13C22 14.6562 20.6562 16 19 16H14V15C14 14.5969 13.7562 14.2312 13.3812 14.075C13.0062 13.9187 12.5781 14.0062 12.2906 14.2906L10.2906 16.2906C9.9 16.6812 9.9 17.3156 10.2906 17.7063L12.2906 19.7063C12.5781 19.9938 13.0062 20.0781 13.3812 19.9219C13.7562 19.7656 14 19.4031 14 18.9969V18H19C21.7625 18 24 15.7625 24 13Z"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "pet__clip0_3715_11209",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white",
				transform: "translate(8 4)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgChangeBrand);
export default ForwardRef;
